import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { weakPasswordsSelector } from '../selectors/dashboardSelector';
import { getWeakPasswordsRequest } from '../actions/dashboardActions';
import WeakPasswords from '../components/WeakPasswords/WeakPasswords';

const mapStateToProps = createStructuredSelector({ weakPasswords: weakPasswordsSelector });
const mapDispatchToProps = { getWeakPasswordsRequest };

export default connect(mapStateToProps, mapDispatchToProps)(WeakPasswords);
